import { render, staticRenderFns } from "./empresas.vue?vue&type=template&id=1c2fb754&"
import script from "./empresas.vue?vue&type=script&lang=js&"
export * from "./empresas.vue?vue&type=script&lang=js&"
import style0 from "./empresas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports